module.exports = __webpack_public_path__ + "img/11_113.1bb64373.png";